var module = angular.module('akimboApp.constants', []);

module.constant('SECURITY_QUESTIONS', [
  {
    key: 0,
    label: "What is your father's middle name?"
  },{
    key: 1,
    label: "What is the name of the street you grew up on?"
  },{
    key: 2,
    label: "What is the name of your first pet?"
  },{
    key: 3,
    label: "What elementary/primary school did you attend?"
  },{
    key: 4,
    label: "What is the name of your favorite teacher?"
  },{
    key: 5,
    label: "What is the first name of your grandfather on your father's side?"
  },{
    key: 6,
    label: "What was your childhood nickname?"
  },{
    key: 7,
    label: "What is the name of a college you applied to but didn't attend?"
  },{
    key: 8,
    label: "Where were you when you had your first kiss?"
  },{
    key: 9,
    label: "What is the first name of the boy or girl that you first kissed?"
  },{
    key: 10,
    label: "What was the last name of your third grade teacher?"
  },{
    key: 11,
    label: "Who is/was your childhood hero?"
  },{
    key: 12,
    label: "What was the first concert you attended?"
  },{
    key: 13,
    label: "What is the most exotic location/country you have visited?"
  },{
    key: 14,
    label: "What is the country of your ultimate dream vacation?"
  },{
    key: 15,
    label: "What was your dream job as a child?"
  }
]);

module.constant('SECURITY_QUESTIONS_MOBILE', [
  {
    key: 0,
    label: "Your father's middle name?"
  },{
    key: 2,
    label: "Name of your first pet?"
  },{
    key: 4,
    label: "Name of your favorite teacher?"
  },{
    key: 6,
    label: "Your childhood nickname?"
  },{
    key: 11,
    label: "Your childhood hero?"
  },{
    key: 12,
    label: "First concert you attended?"
  },{
    key: 15,
    label: "Dream job as a child?"
  }
]);


module.constant('IAVOBJECTS', [
  'customerIdentifier',
  'accountNumberEntered',
  'routingNumberInput',
  'institutionName',
  'firstNameEntered',
  'lastNameEntered',
  'amountInput',
  'isLoginValid',
  'accountNumberConfidence',
  'isAccountNumberMatch',
  'accountNumberFound',
  'holderNameConfidence',
  'isHolderNameMatch',
  'holderNameFound',
  'isAmountVerified',
  'amountFound',
  'isVerified',
  'bankType',
  'totalDeposits',
  'totalWithdrawals',
  'transactionsFromDate',
  'transactionsToDate'
]);

module.constant('STATES',[
  {
    state: 'Alaska',
    key: 'AK'
  },
  {
    state: 'Alabama',
    key: 'AL'
  },
  {
    state: 'Arkansas',
    key: 'AR'
  },
  {
    state: 'Arizona',
    key: 'AZ'
  },
  {
    state: 'California',
    key: 'CA'
  },
  {
    state: 'Colorado',
    key: 'CO'
  },
  {
    state: 'Connecticut',
    key: 'CT'
  },
  {
    state: 'District of Columbia',
    key: 'DC'
  },
  {
    state: 'Delaware',
    key: 'DE'
  },
  {
    state: 'Florida',
    key: 'FL'
  },
  {
    state: 'Georgia',
    key: 'GA'
  },
  {
    state: 'Hawaii',
    key: 'HI'
  },
  {
    state: 'Iowa',
    key: 'IA'
  },
  {
    state: 'Idaho',
    key: 'ID'
  },
  {
    state: 'Illinois',
    key: 'IL'
  },
  {
    state: 'Indiana',
    key: 'IN'
  },
  {
    state: 'Kansas',
    key: 'KS'
  },
  {
    state: 'Kentucky',
    key: 'KY'
  },
  {
    state: 'Louisiana',
    key: 'LA'
  },
  {
    state: 'Massachusetts',
    key: 'MA'
  },
  {
    state: 'Maryland',
    key: 'MD'
  },
  {
    state: 'Maine',
    key: 'ME'
  },
  {
    state: 'Michigan',
    key: 'MI'
  },
  {
    state: 'Minnesota',
    key: 'MN'
  },
  {
    state: 'Missouri',
    key: 'MO'
  },
  {
    state: 'Mississippi',
    key: 'MS'
  },
  {
    state: 'Montana',
    key: 'MT'
  },
  {
    state: 'North Carolina',
    key: 'NC'
  },
  {
    state: 'North Dakota',
    key: 'ND'
  },
  {
    state: 'Nebraska',
    key: 'NE'
  },
  {
    state: 'New Hampshire',
    key: 'NH'
  },
  {
    state: 'New Jersey',
    key: 'NJ'
  },
  {
    state: 'New Mexico',
    key: 'NM'
  },
  {
    state: 'Nevada',
    key: 'NV'
  },
  {
    state: 'New York',
    key: 'NY'
  },
  {
    state: 'Ohio',
    key: 'OH'
  },
  {
    state: 'Oklahoma',
    key: 'OK'
  },
  {
    state: 'Oregon',
    key: 'OR'
  },
  {
    state: 'Pennsylvania',
    key: 'PA'
  },
  {
    state: 'Puerto Rico',
    key: 'PR',
  },
  {
    state: 'Rhode Island',
    key: 'RI'
  },
  {
    state: 'South Carolina',
    key: 'SC'
  },
  {
    state: 'South Dakota',
    key: 'SD'
  },
  {
    state: 'Tennessee',
    key: 'TN'
  },
  {
    state: 'Texas',
    key: 'TX'
  },
  {
    state: 'Utah',
    key: 'UT'
  },
  {
    state: 'Vermont',
    key: 'VT'
  },
  {
    state: 'Virgin Islands',
    key: 'VI'
  },
  {
    state: 'Virginia',
    key: 'VA'
  },
  {
    state: 'Washington',
    key: 'WA'
  },
  {
    state: 'Wisconsin',
    key: 'WI'
  },
  {
    state: 'West Virginia',
    key: 'WV'
  },
  {
    state: 'Wyoming',
    key: 'WY'
  }
]);

module.constant('FREQUENCY_OPTIONS', [
  {
    key: 'E',
    label: 'Every Week'
  },{
    key: 'F',
    label: 'Every 2 Weeks'
  },{
    key: 'O',
    label: 'Once a Month'
  },{
    key: 'T',
    label: 'Twice a Month'
  }
]);

module.constant('DAY_OF_WEEK', [
  {
    key: '0',
    label: 'Sunday'
  },{
    key: '1',
    label: 'Monday'
  },{
    key: '2',
    label: 'Tuesday'
  },{
    key: '3',
    label: 'Wednesday'
  },{
    key: '4',
    label: 'Thursday'
  },{
    key: '5',
    label: 'Friday'
  }, {
    key: '6',
    label: 'Saturday'
  }
]);

module.constant('DAY_OF_MONTH', [
  {
    key: '1',
    label: '1'
  },{
    key: '2',
    label: '2'
  },{
    key: '3',
    label: '3'
  },{
    key: '4',
    label: '4'
  },{
    key: '5',
    label: '5'
  },{
    key: '6',
    label: '6'
  },{
    key: '7',
    label: '7'
  },{
    key: '8',
    label: '8'
  },{
    key: '9',
    label: '9'
  },{
    key: '10',
    label: '10'
  },{
    key: '11',
    label: '11'
  },{
    key: '12',
    label: '12'
  },{
    key: '13',
    label: '13'
  },{
    key: '14',
    label: '14'
  },{
    key: '15',
    label: '15'
  },{
    key: '16',
    label: '16'
  },{
    key: '17',
    label: '17'
  },{
    key: '18',
    label: '18'
  },{
    key: '19',
    label: '19'
  },{
    key: '20',
    label: '20'
  },{
    key: '21',
    label: '21'
  },{
    key: '22',
    label: '22'
  },{
    key: '23',
    label: '23'
  },{
    key: '24',
    label: '24'
  },{
    key: '25',
    label: '25'
  },{
    key: '26',
    label: '26'
  },{
    key: '27',
    label: '27'
  },{
    key: '28',
    label: '28'
  },{
    key: '29',
    label: '29'
  },{
    key: '30',
    label: '30'
  },{
    key: '31',
    label: '31'
  }
]);

module.constant('AUTH_EVENTS', {
  loginSuccess: 'auth-login-success',
  loginFailed: 'auth-login-failed',
  logoutSuccess: 'auth-logout-success',
  sessionTimeout: 'auth-session-timeout',
  notAuthenticated: 'auth-not-authenticated',
  notAuthorized: 'auth-not-authorized'
});

module.constant('OVERLAY', {
  'member.home.transaction': {
    title: 'POS Purchase',
    icon: 'icon-shopping-cart',
    headerClass: 'overlay-alt-2-bkg'
  },
  'member.home.directdeposit': {
    title: 'DIRECT DEPOSIT',
    icon: 'icon-akimbo-DD',
    headerClass: 'overlay-alt-bkg'
  },
  'member.home.corpdeposit': {
    title: 'ACH & WIRE INSTRUCTIONS',
    icon: 'icon-akimbo-DD',
    headerClass: 'overlay-alt-bkg'
  },
  'member.home.ach': {
    title: 'Bank Withdrawal',
    icon: 'icon-akimbo-DD',
    headerClass: 'overlay-alt-2-bkg'
  },
  'member.home.send-check': {
    title: 'Send Check',
    icon: 'icon-check-deposit',
    headerClass: 'overlay-alt-2-bkg'
  },
  'member.home.debit-card-withdrawal': {
    title: 'Instant Bank Withdrawal',
    icon: 'icon-akimbo-withdraw',
    headerClass: 'overlay-alt-2-bkg'
  },
  'member.home.paypal': {
    title: 'PayPal',
    icon: 'icon-paypal',
    headerClass: 'overlay-alt-2-bkg'
  },
  'member.home.venmo': {
    title: 'Venmo',
    icon: 'icon-venmo',
    headerClass: 'overlay-alt-2-bkg'
  },
  'member.home.virtual': {
    title: 'VIRTUAL CARD',
    icon: 'icon-single-card',
    headerClass: ''
  },
  'member.home.send-physical-card': {
    title: 'SEND PHYSICAL CARD',
    icon: 'icon-single-card',
    headerClass: ''
  },
  'member.home.upgrade': {
    title: 'UPGRADE',
    icon: 'icon-akimbo-logo',
    headerClass: 'overlay-upgrade-bkg'
  },
  'member.home.bank/load': {
    title: 'BANK LOAD',
    icon: 'icon-akimbo-bank-load',
    headerClass: 'overlay-alt-bkg'
  },
  'member.home.bank/add': {
    title: 'ADD BANK',
    icon: 'icon-bank-add',
    headerClass: 'overlay-gray-6-bkg'
  },
  'member.home.bank/load/recurring': {
    title: 'SET UP AUTO BANK LOAD',
    icon: 'icon-bank-auto',
    headerClass: 'overlay-alt-bkg'
  },
  'member.home.bank/load/recurring/manage': {
    title: 'MANAGE AUTO CARD LOAD',
    icon: 'icon-bank-auto',
    headerClass: 'overlay-alt-bkg'
  },
  'member.home.send/recurring/manage': {
    title: 'MANAGE AUTO CARD SENDS',
    icon: 'icon-icon-akimbo-send',
    headerClass: 'overlay-alt-2-bkg'
  },
  'member.home.transfers/manage': {
    title: 'MANAGE AUTO TRANSFERS',
    icon: 'icon-autotransfer',
    headerClass: 'overlay-gray-6-bkg'
  },
  'member.home.bank/manage': {
    title: 'MANAGE BANKS',
    icon: 'icon-akimbo-bank-load',
    headerClass: 'overlay-gray-6-bkg'
  },
  'member.home.limits/list': {
    title: 'Card Restrictions',
    icon: 'icon-akimbo-bank-load',
    headerClass: 'overlay-gray-6-bkg'
  },
  'member.home.rdc/load': {
    title: 'CHECK LOAD',
    icon: 'icon-ingo',
    headerClass: 'overlay-alt-bkg'
  },
  'member.home.cash/load': {
    title: 'CASH LOAD',
    icon: 'icon-akimbo-money',
    headerClass: 'overlay-alt-bkg'
  },
  'member.home.bank/withdraw': {
    title: 'WITHDRAW',
    icon: 'icon-akimbo-withdraw',
    headerClass: 'overlay-alt-2-bkg'
  },
  'member.home.bank/withdraw/recurring': {
    title: 'SET UP AUTO WITHDRAWAL',
    icon: 'icon-bank-auto',
    headerClass: 'overlay-alt-2-bkg',
  },
  'member.home.bank/withdraw/recurring/manage': {
    title: 'MANAGE AUTO CARD WITHDRAW',
    icon: 'icon-bank-auto',
    headerClass: 'overlay-alt-2-bkg',
  },
  'member.home.bank/detail': {
    title: 'MANAGE BANKS',
    icon: 'icon-akimbo-bank-load',
    headerClass: 'overlay-gray-6-bkg'
  },
  'member.home.billpay.list': {
    title: 'SEND CHECK',
    icon: 'icon-bill-pay',
    headerClass: 'overlay-alt-2-bkg'
  },
  'member.home.send/transfer': {
    title: 'SEND FUNDS',
    icon: 'icon-akimbo-send',
    headerClass: 'overlay-alt-2-bkg'
  },
  'member.home.request': {
    title: 'REQUEST FUNDS',
    icon: 'icon-akimbo-request',
    headerClass: 'overlay-alt-bkg'
  },
  'member.home.send/recurring': {
    title: 'SET UP AUTO SEND',
    icon: 'icon-akimbo-send',
    headerClass: 'overlay-alt-2-bkg'
  },
  'member.home.subaccount/add': {
    title: 'ADD CARD',
    icon: 'icon-card-sub',
    headerClass: 'overlay-gray-6-bkg'
  },
  'member.home.subcard/load': {
    title: 'LOAD CARD',
    icon: 'icon-akimbo-send',
    headerClass: 'overlay-alt-bkg'
  },
  'member.home.subcard/load/recurring': {
    title: 'SET UP AUTO BANK LOAD',
    icon: 'icon-subs-auto',
    headerClass: 'overlay-alt-2-bkg'
  },
  'member.home.subcard/profile': {
    title: 'CARD PROFILE',
    icon: 'icon-subs-group',
    headerClass: ' '
  },
  'member.home.retrieve': {
    title: 'RETRIEVE FUNDS',
    icon: 'icon-akimbo-request',
    headerClass: 'overlay-alt-2-bkg'
  },
  'member.home.subcard/enable': {
    title: 'ENABLE CARD',
    icon: 'icon-card-activate',
    headerClass: ' '
  },
  'member.home.subcard/disable': {
    title: 'DISABLE CARD',
    icon: 'icon-card-disable',
    headerClass: ' '
  },
  'member.home.subcard/close': {
    title: 'CLOSE CARD',
    icon: 'icon-card-disable',
    headerClass: ' '
  },
  'member.home.profile/password': {
    title: 'CHANGE PASSWORD',
    icon: 'icon-lock-legacy',
    headerClass: 'overlay-gray-6-bkg'
  },
  'member.home.profile/changepin': {
    title: 'CHANGE PIN',
    icon: 'icon-card-pin',
    headerClass: 'overlay-gray-6-bkg'
  },
  'member.home.profile/reissue': {
    title: 'REISSUE CARD',
    icon: 'icon-single-card',
    headerClass: 'overlay-gray-6-bkg'
  },
  'member.home.profile/activate': {
    title: 'ACTIVATE CARD',
    icon: 'icon-card-activate',
    headerClass: ' '
  },
  'member.home.block/load': {
    title: 'ATTENTION',
    icon: 'icon-card-activate',
    headerClass: 'overlay-gray-6-bkg'
  },
  'member.home.block/fraud': {
    title: 'ATTENTION',
    icon: 'icon-card-activate',
    headerClass: 'overlay-gray-6-bkg'
  },
  'member.home.profile/smsmanage': {
    title: 'MANAGE TEXT ALERTS',
    icon: 'icon-alerts',
    headerClass: 'overlay-gray-6-bkg'
  },
  'member.home.profile/statements': {
    title: 'STATEMENTS',
    icon: 'icon-feed',
    headerClass: 'overlay-gray-6-bkg'
  },
  'member.home.profile/feesummary': {
    title: 'FEE SUMMARY',
    icon: 'icon-feed',
    headerClass: 'overlay-gray-6-bkg'
  },
  'member.home.profile': {
    title: 'PROFILE',
    icon: 'icon-sub',
    headerClass: 'overlay-gray-6-bkg'
  },
  'member.home.profile/atm': {
    title: 'ATM ACCESS',
    icon: 'icon-akimbo-atm',
    headerClass: 'overlay-gray-6-bkg'
  },
  'member.home.profile/verification': {
    title: 'VERIFICATION STATUS',
    icon: 'icon-alerts',
    filter: ['home', 'sub'],
    access: 'primary sub',
    headerClass: ' '
  },
  'member.home.profile/wallet': {
    title: 'Digital Wallet',
    icon: 'icon-PIN',
    headerClass: ''
  }
});

// Widgets that get injected for certain CH use-cases
module.constant('OPTIONAL_WIDGETS', {
  'uptogetherManageBanks': {
    title: 'Manage Banks',
    color: ' ',
    state: 'member.home.bank/manage.list',
    icon: 'icon-bank-manage',
    access: 'incentive'
  },
  'manageBanks': {
    title: 'Manage Banks',
    color: ' ',
    state: 'member.home.bank/manage.list',
    icon: 'icon-bank-manage',
    access: 'gpr-main expense-main'
  },
  'uptogetherManageTransfers': {
    title: 'Manage Transfers',
    color: ' ',
    state: 'member.home.transfers/manage.list',
    icon: 'icon-autotransfer',
    access: 'incentive'
  },
  'withdraw': {
    title: 'Withdraw',
    color: 'blue',
    state: 'member.home.bank/transfer.step1({transferType:"withdraw"})',
    params: {
      transferType: 'withdraw',
    },
    icon: 'icon-akimbo-withdraw',
    access: 'gpr-main expense-main'
},
  'uptogetherWithdraw': {
    title: 'Withdraw',
    color: 'blue',
    state: 'member.home.bank/transfer.step1({transferType:"withdraw"})',
    params: {
      transferType: 'withdraw',
    },
    icon: 'icon-akimbo-withdraw',
    access: 'incentive'
  },
  'atmAccess': {
    title: 'ATM Access',
    color: ' ',
    state: 'member.home.profile/atm.step1',
    icon: 'icon-akimbo-atm',
    access: 'gpr-sub expense-sub incentive'
  },
  'verifyAccount': {
    title: 'Verify Your Account',
    color: 'notification',
    state: 'member.home.profile/verification.step1',
    icon: 'icon-card-activate',
    access: 'gpr-main expense-main'
  },
  'activateCard': {
    title: 'Activate Card',
    color: 'notification',
    state: 'member.home.profile/activate.step1',
    icon: 'icon-card-activate',
    access: 'all'
  },
  'loadBlock': {
    title: 'Attention',
    color: 'notification',
    state: 'member.home.block/load.step1',
    icon: 'icon-card-activate',
    access: 'gpr expense'
  },
  'fraudBlock': {
    title: 'Attention',
    color: 'notification',
    state: 'member.home.profile/verification.step1',
    icon: 'icon-card-activate',
    access: 'all'
  },
  'enableSub': {
    title: 'Enable Card',
    color: ' ',
    state: 'member.home.subaccount/enable.step1',
    icon: 'icon-card-activate',
    access: 'gpr incentive gift expense-sub'
  },
  'disableSub': {
    title: 'Disable Card',
    color: ' ',
    state: 'member.home.subaccount/disable.step1',
    icon: 'icon-card-disable',
    access: 'gpr incentive gift expense-sub'
  },
  'closeSub': {
    title: 'Close Card',
    color: ' ',
    state: 'member.home.subaccount/close.step1',
    icon: 'icon-card-disable',
    access: 'gpr expense-sub'
  },
  'loadSubCard': {
    title: 'Load Sub',
    color: 'green',
    state: 'member.home.subaccount/load.step1',
    icon: 'icon-akimbo-send',
    access: 'gpr-sub expense-sub'
  },
  'viewVirtualCard': {
    title: 'View Virtual Card',
    color: 'notification',
    state: 'member.home.subaccount/virtual.step1',
    icon: 'icon-single-card',
    access: 'all'
  },
  'retrieveFunds': {
    title: 'Retrieve Funds',
    color: 'blue',
    state: 'member.home.subaccount/search.step1',
    icon: 'icon-akimbo-request',
    access: 'gpr-main expense-main'
  },
  'retrieveFundsSub': {
    title: 'Retrieve Funds',
    color: 'blue',
    state: 'member.home.subaccount/retrieve.step1',
    icon: 'icon-akimbo-request',
    access: 'gpr-sub expense-sub'
  },
  'manageAutoTransfers': {
    title: 'Manage Transfers',
    color: ' ',
    state: 'member.home.transfers/manage.list',
    icon: 'icon-autotransfer',
    access: 'gpr-main expense-main'
  },
  'addSubCard': {
    title: 'Add Cards',
    color: ' ',
    state: 'member.home.subaccount/add.step1',
    icon: 'icon-card-sub',
    access: 'gpr-main expense-main'
  },
  'sendPhysicalCard': {
    title: 'Send Physical Card',
    color: 'notification',
    state: 'member.home.send-physical-card.step1',
    icon: 'icon-single-card',
    access: 'all'
  },
  'achBank': {
    title: 'Bank Withdrawal',
    color: 'blue',
    state: 'member.home.ach.step1',
    icon: 'icon-akimbo-DD',
    access: 'incentive'
  },
  'sendCheck': {
    title: 'Send Check',
    color: 'blue',
    state: 'member.home.send-check.step1',
    icon: 'icon-check-deposit',
    access: 'incentive'
  },
  'paypalWithdraw': {
    title: 'Paypal',
    color: 'blue',
    state: 'member.home.paypal.step1',
    icon: 'icon-paypal',
    access: 'all'
  },
  'venmoWithdraw': {
    title: 'Venmo',
    color: 'blue',
    state: 'member.home.venmo.step1',
    icon: 'icon-venmo',
    access: 'all'
  },
  'debitCardWithdrawal': {
    title: 'Instant Bank Withdrawal',
    color: 'blue',
    state: 'member.home.debit-card-withdrawal.step1',
    icon: 'icon-akimbo-withdraw',
    filter: ['home', 'sub', 'virtual'],
    access: 'all'
  },
  'cardLimits': {
    title: 'Card Restrictions',
    color: ' ',
    state: 'member.home.limits.list',
    icon: 'icon-bank-manage',
    access: 'all'
  },
});


// Default widgets available to CH
module.constant('WIDGETS', [
  {
    title: 'Bank Load',
    color: 'green',
    state: 'member.home.bank/transfer.step1({ transferType: "load" })',
    params: {
      transferType: 'load',
    },
    icon: 'icon-akimbo-bank-load',
    access: 'gpr-main expense-main'
  },{
    title: 'Check Load',
    color: 'green',
    state: 'member.home.rdc/load.step1',
    icon: 'icon-ingo',
    access: 'gpr-main'
  },{
    title: 'Cash Load',
    color: 'green',
    state: 'member.home.cash/load.step1',
    icon: 'icon-cash',
    access: 'gpr-main'
  }, {
    title: 'Send Funds',
    color: 'blue',
    state: 'member.home.send/transfer.step1',
    icon: 'icon-akimbo-send',
    access: 'gpr-main expense-main'
  },{
    title: 'Request Funds',
    color: 'green',
    state: 'member.home.request.step1',
    icon: 'icon-akimbo-request',
    access: 'gpr-main'
  },{
    title: 'Auto Send Funds',
    color: 'blue',
    state: 'member.home.send/recurring.step1',
    icon: 'icon-icon-akimbo-send',
    access: 'gpr-main expense-main'
  },{
    title: 'Account Settings',
    color: ' ',
    state: 'member.home.profile.step1',
    icon: 'icon-sub',
    access: 'all'
  },{
    title: 'Change Pin',
    color: ' ',
    state: 'member.home.profile/changepin.step1',
    icon: 'icon-card-pin',
    access: 'all'
  },{
    title: 'Manage Alerts',
    color: ' ',
    state: 'member.home.profile/smsmanage.step1',
    icon: 'icon-alerts',
    access: 'all'
  },{
    title: 'View Statements',
    color: ' ',
    state: 'member.home.profile/statements.step1',
    icon: 'icon-feed',
    access: 'all'
  },{
    title: 'View Fees',
    color: ' ',
    state: 'member.home.profile/feesummary.step1',
    icon: 'icon-feed',
    access: 'all'
  },{
    title: 'Add to Digital Wallet',
    color: ' ',
    state: 'member.home.profile/wallet.step1',
    icon: 'icon-PIN',
    access: 'all'
  },{
    title: 'Reissue Card',
    color: ' ',
    state: 'member.home.profile/reissue.step1',
    icon: 'icon-single-card',
    access: 'all'
  },
  {
    title: 'Activate Card',
    color: ' ',
    state: 'member.home.profile/activate.step1',
    icon: 'icon-card-activate',
    access: 'all'
  },
  {
    title: 'Direct Deposit',
    color: 'green',
    state: 'member.home.directdeposit.step1',
    icon: 'icon-akimbo-DD',
    access: 'gpr-main'
  },
  {
    title: 'ACH & Wire Instructions',
    color: 'green',
    state: 'member.home.corpdeposit.step1',
    icon: 'icon-akimbo-DD',
    access: 'expense-main'
  },
]);

// Enrollment Validation
module.constant('EV_STEP1', {
  'Email': {message: 'Please provide your email address.'},
  'Dob1': {message: 'Please provide your birth month.'},
  'Dob2': {message: 'Please provide your birth day.'},
  'Dob3': {message: 'Please provide your birth year.'},
  'Phone1': {message: 'Please provide the area code for your phone number.'},
  'Phone2': {message: 'Please provide your phone number.'},
  'Phone3': {message: 'Please provide your phone number.'}
});

module.constant('EV_STEP2', {
  'FirstName': {message: 'Please provide your first name.'},
  'LastName': {message: 'Please provide your last name.'},
  'StreetAddress': {message: 'Please provide your street address.'},
  'City': {message: 'Please provide your city of residence.'},
  'State': {message: 'Please provide your current state of residence.'},
  'Zipcode': {message: 'Please provide your zipcode.'},
  'Ssn1': {message: 'Please enter a social security number or select that you do not have a social security number. '},
  'Ssn2': {message: 'Please provide the middle 2 digits of your social security number.'},
  'Ssn3': {message: 'Please provide the last 4 digits of your social security number.'}
});

module.constant('EV_STEP3', {
  'Username': {message: 'Please provide the username for your account.'},
  'Password': {message: 'Please provide a password for your account. Password must be at least 8 characters and 1 number.'},
  'Password1': {message: 'Please confirm your password.'},
  'SecurityQuestionOption1': {message: 'Please select a security question to answer.'},
  'SecurityAnswer1': {message: 'Please answer your first security question.'},
  'SecurityQuestionOption2': {message: 'Please select a second security question to answer.'},
  'SecurityAnswer2': {message: 'Please provide an answer for your second security question.'}
});

module.constant('ENROLLMENT_ERROR', [
  'We were unable to identify you with the information provided.  Please make sure you have provided your full legal name and correct Social Security number and date of birth above.  If you have recently changed your name, you may need to provide your previously used legal name.',
  'Sorry, we were unable to process your enrollment at this time.  Please try again later. Code ',
  'Sorry, we were unable to process your enrollment at this time.  Please try again later.'
]);

module.constant('RETRYURLS', [
  'http://app3.akimbocard.com/api/v2/card/status',
  'http://app3.akimbocard.com/api/v2/card/balance',
  'http://app3.akimbocard.com/api/v2/cardholder/profile',
  'http://app3.akimbocard.com/api/v2/card/sub-cards',
  'http://app3.akimbocard.com/api/v2/transactions/all/0/15',
  'http://app3.akimbocard.com/api/v2/transactions/transfer/0/15',
  'http://app3.akimbocard.com/api/v2/transactions/load/0/15',
  'http://app3.akimbocard.com/api/v2/transactions/withdraw/0/15',
  'https://app.akimbocard.com/api/v2/card/status',
  'https://app.akimbocard.com/api/v2/card/balance',
  'https://app.akimbocard.com/api/v2/cardholder/profile',
  'https://app.akimbocard.com/api/v2/card/sub-cards',
  'https://app.akimbocard.com/api/v2/transactions/all/0/15',
  'https://app.akimbocard.com/api/v2/transactions/transfer/0/15',
  'https://app.akimbocard.com/api/v2/transactions/load/0/15',
  'https://app.akimbocard.com/api/v2/transactions/withdraw/0/15'
]);
